/**
 * サーバーから返されるISO 8601形式の日付を
 * HTMLのdatetime-local入力フィールド用の形式に変換する
 */
export const formatDateTimeForClient = (
  isoDateString?: string | null,
): string => {
  if (!isoDateString || isoDateString.trim() === '') {
    return '';
  }

  try {
    // ISO 8601形式の文字列をDateオブジェクトに変換
    const date = new Date(isoDateString);

    // 無効な日付の場合は空文字を返す
    if (Number.isNaN(date.getTime())) {
      return '';
    }

    // JST（日本時間）でのYYYY-MM-DDTHH:mm形式に変換
    // toLocaleDateStringとtoLocaleTimeStringを使用してJST時間を取得
    const jstDate = new Date(
      date.toLocaleString('ja-JP', {timeZone: 'Asia/Tokyo'}),
    );

    const year = jstDate.getFullYear();
    const month = String(jstDate.getMonth() + 1).padStart(2, '0');
    const day = String(jstDate.getDate()).padStart(2, '0');
    const hours = String(jstDate.getHours()).padStart(2, '0');
    const minutes = String(jstDate.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  } catch (error) {
    console.warn('日付フォーマット変換エラー:', error);
    return '';
  }
};

/**
 * サーバーから返されるISO 8601形式の日付を
 * YYYY/MM/DD形式に変換する
 */
export const formatDateForClient = (isoDateString?: string | null): string => {
  if (!isoDateString || isoDateString.trim() === '') {
    return '';
  }

  try {
    // ISO 8601形式の文字列をDateオブジェクトに変換
    const date = new Date(isoDateString);

    // 無効な日付の場合は空文字を返す
    if (Number.isNaN(date.getTime())) {
      return '';
    }

    // JST（日本時間）でのYYYY/MM/DD形式に変換
    const jstDate = new Date(
      date.toLocaleString('ja-JP', {timeZone: 'Asia/Tokyo'}),
    );

    const year = jstDate.getFullYear();
    const month = String(jstDate.getMonth() + 1).padStart(2, '0');
    const day = String(jstDate.getDate()).padStart(2, '0');

    return `${year}/${month}/${day}`;
  } catch (error) {
    console.warn('日付フォーマット変換エラー:', error);
    return '';
  }
};
